import type { RoomDef } from '../../sim/room';

/**
 * The Ranger's arena on Mars (GDD: Rogue suit bosses). A walled floor in
 * every lane with a few planks to hop a charge from; the doors on the right stay shut until the
 * Ranger is beaten. Played after Mars's seeded rooms, or straight away with `?room=boss`.
 */
export const RANGER_ARENA: RoomDef = {
  id: 'ranger-arena',
  name: 'Ranger arena',
  lanes: [
    [
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##...........*................................##',
      '##..........=====..............=====........XX##',
      '##..........................................XX##',
      '##..........................................XX##',
      '##..P.......................................XX##',
      '################################################',
      '################################################',
      '################################################',
    ],
    [
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##.....................*......................##',
      '##..................=======...................##',
      '##..........................................XX##',
      '##..........................................XX##',
      '##..........................................XX##',
      '##................................R.........XX##',
      '################################################',
      '################################################',
      '################################################',
    ],
    [
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##............................................##',
      '##........*...........................*.......##',
      '##......=====.......................=====.....##',
      '##............................................##',
      '##..........................................XX##',
      '##..........................................XX##',
      '##..........................................XX##',
      '##..........................................XX##',
      '################################################',
      '################################################',
      '################################################',
    ],
  ],
};
